import logo from "../../Components/Icons/FooterLogo.svg";
import phone from "../../Components/Icons/phone.svg";
import email from "../../Components/Icons/email.svg";
import insta from "../../Components/Icons/Instagram.svg";
import linkin from "../../Components/Icons/LinkedIn.svg";
import './IComponents.css';


export default function Footer(){

    return (
        <footer>
            <div className={"footer-div"}>
                <img src={logo} alt="Logo" />
               
            </div>
            <div className={"footer-div"}>
            </div>
            <div className={"footer-div"}>

                <h2>Contact Info.</h2>
                <hr></hr>
                <br></br>
                <div className={"contact-detail"}>
                    <img className={"detail-logo"} src={phone} />
                    <p>+356 9996 7850</p>
                </div>
                <div className={"contact-detail"}>
                    <img className={"detail-logo"} src={email} />
                    <p>uziel.ohayon.designs@gmail.com</p>
                </div>
               <br></br>
                <div className={"contact-detail"}>
                    <a href={"https://www.instagram.com/uod584?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="}><img className={"detail-logo"} src={insta} /></a>
                    <a href={"https://www.linkedin.com/in/uziel-ohayon-7a2577225/"}><img className={"detail-logo"} src={linkin} /></a>
                </div>
                
            </div>

        </footer>
    )
}